import { createFileRoute } from '@tanstack/react-router';

import { AuditCalendarPage } from '@/features/audit-workflow/components/AuditCalendarPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/audit/calendar')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.auditCalendar'),
  }),
  component: AuditCalendarRoute,
});

function AuditCalendarRoute() {
  return <AuditCalendarPage />;
}
